import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { PersonIcon } from '@/shared/ui/display/EmojiIcon';
import useSWR from 'swr';
import { getPlannerById } from '@/entities/planner';
import { fontSize, typography } from '@/shared/theme';

interface PlannerChipProps {
  plannerId: string;
  /** 상위에서 배치 fetch한 경우 전달. 있으면 useSWR 스킵 */
  planner?: { name: string };
}

export function PlannerChip({ plannerId, planner: plannerFromProps }: PlannerChipProps) {
  const { data: plannerFromSwr, isLoading } = useSWR(
    plannerFromProps ? null : plannerId ? ['planner-by-id', plannerId] : null,
    () => getPlannerById(plannerId),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true,
      dedupingInterval: 3600000,
    }
  );

  const planner = plannerFromProps ?? plannerFromSwr;

  if (!planner && isLoading) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        <PersonIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        <Typography
          component="span"
          sx={{
            fontSize: fontSize.sm,
            color: 'text.secondary',
            fontStyle: 'italic',
          }}
        >
          로딩 중...
        </Typography>
      </Box>
    );
  }

  const label = planner ? `${planner.name} 플래너님` : '알 수 없음';

  return (
    <Chip
      icon={<PersonIcon sx={{ fontSize: 14 }} />}
      label={label}
      size="small"
      variant="outlined"
      sx={{
        height: 22,
        fontSize: fontSize.sm,
        fontWeight: typography.cell.fontWeight,
        '& .MuiChip-icon': {
          marginLeft: 0.5,
          marginRight: 0,
        },
      }}
    />
  );
}
